import { redirect } from "react-router";

import { store } from "@src/index";
import { ILeague } from "@src/types/api";

import {
    leagueManagementActions,
    selectSelectedLeague,
} from "@features/leaguemgmt/leagueManagementSlice";

const loader = async ({ params }: any) => {
    let { leagueId, teamId } = params;
    let league: ILeague | undefined;
    leagueId = parseInt(leagueId);
    teamId = parseInt(teamId);

    let leagues = store.getState().leaguemanagement.leagues;
    const leaguesPromise = leagues.length
        ? Promise.resolve()
        : store.dispatch(leagueManagementActions.getLeagues());

    const selectedLeague = selectSelectedLeague(store.getState());

    await Promise.all([leaguesPromise]);

    if (selectedLeague?.id !== leagueId) {
        store.dispatch(leagueManagementActions.setSelectedLeague(leagueId));
        league = selectSelectedLeague(store.getState());
    } else {
        league = selectedLeague;
    }

    const header = `${league?.ageLevel}${
        league?.designation ? ` ${league.designation}` : ""
    }${league?.direction ? ` ${league.direction}` : ""} Standings`;

    if (teamId && !league?.teams?.map(t => t.id).includes(teamId)) {
        return redirect(`/leagues/${leagueId}`);
    }

    return {
        league,
        header,
    };
};

export default loader;
